import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props, data) {
  let id = useDataValue({
    viewPath: props.viewPath,
    context: 'selected',
    path: 'person_id',
  })

  return {
    variables: {
      id,
    },
    pause: !id,
  }
}
